import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mb-10" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = { class: "card-body pt-9 pb-0" }
const _hoisted_4 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_5 = { class: "me-7 mb-4" }
const _hoisted_6 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = {
  href: "javasript:;",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_12 = { href: "javascript:;" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_15 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_16 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_17 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_19 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_20 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_21 = { class: "d-flex mt-6" }
const _hoisted_22 = { class: "me-0" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { class: "my-2 fs-6" }, "* For EC Members  ", -1)
const _hoisted_24 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_25 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_26 = { class: "d-flex flex-wrap" }
const _hoisted_27 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_30 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  All USID Balance", -1)
const _hoisted_32 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_35 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_36 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_37 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_40 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  EC Wallet", -1)
const _hoisted_42 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_43 = { class: "d-flex align-items-center" }
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, null, -1)
const _hoisted_45 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Travel GC", -1)
const _hoisted_47 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_50 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Product GC", -1)
const _hoisted_52 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_53 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_54 = { class: "nav-item" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Reminders ")
const _hoisted_56 = { class: "nav-item" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Account Info ")
const _hoisted_58 = { class: "nav-item" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Prime Monitoring ")
const _hoisted_60 = { class: "nav-item" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" My Coverage ")
const _hoisted_62 = { class: "nav-item" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Available Coverage ")
const _hoisted_64 = { class: "nav-item" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Package Points ")
const _hoisted_66 = { class: "nav-item" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" DreamLyf ")
const _hoisted_68 = { class: "nav-item" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" OVI KYB ")
const _hoisted_70 = { class: "row gy-5 g-xl-8" }
const _hoisted_71 = {
  type: "button",
  ref: "addAccountModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#add_new_accountmodal`
}
const _hoisted_72 = {
  type: "button",
  ref: "encodeNowSealproModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#encode_now_sealpromodal`
}
const _hoisted_73 = {
  type: "button",
  ref: "encodeNowSealproAutoCoverageModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#encode_now_sealproautocoverage_modal`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OVIAdvisory = _resolveComponent("OVIAdvisory")
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")
  const _component_SealProEncode = _resolveComponent("SealProEncode")
  const _component_SealProAutoCoverage = _resolveComponent("SealProAutoCoverage")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_OVIAdvisory, { class: "mb-10" }),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("img", {
        src: _ctx.echequeUrl,
        style: {"max-width":"100% !important","height":"auto !important"}
      }, null, 8, ["src"])
    ], 512), [
      [_vShow, _ctx.showEChequeImage]
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("img", {
                src: _ctx.user.avatar,
                alt: "image"
              }, null, 8, ["src"]),
              (_ctx.showRankImage)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: _ctx.rankPrimeImage,
                    class: "",
                    height: "50",
                    width: "50",
                    style: _ctx.rankPrimeImageStyle
                  }, null, 12, ["src"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("a", _hoisted_11, _toDisplayString(_ctx.user.fname) + " " + _toDisplayString(_ctx.user.lname), 1),
                  _createVNode("a", _hoisted_12, [
                    _createVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Verified.svg" })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("a", _hoisted_15, [
                    _createVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.user.usid), 1)
                  ]),
                  _createVNode("a", _hoisted_17, [
                    _createVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Map/Marker1.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.user.address), 1)
                  ]),
                  _createVNode("a", _hoisted_19, [
                    _createVNode("span", _hoisted_20, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Mail-at.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.user.email), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode("button", {
                    class: "btn btn-sm btn-secondary me-3",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addAccount()))
                  }, "ADD OVI ACCOUNT ")
                ])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _withDirectives(_createVNode("div", null, [
                  _createVNode(_component_el_skeleton, {
                    rows: 2,
                    animated: ""
                  })
                ], 512), [
                  [_vShow, _ctx.loadingBalance]
                ]),
                _withDirectives(_createVNode("div", _hoisted_26, [
                  _withDirectives(_createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode("div", _hoisted_30, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.dashboarddata.overAllAvailableBalance).toFixed(2))) + " " + _toDisplayString(_ctx.dashboarddata.currency), 1)
                    ]),
                    _hoisted_31
                  ], 512), [
                    [_vShow, !_ctx.loadingBalance]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_32, [
                    _createVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode("div", _hoisted_35, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.dashboarddata.balance).toFixed(2))) + " " + _toDisplayString(_ctx.dashboarddata.currency), 1)
                    ]),
                    _createVNode("div", _hoisted_36, "  " + _toDisplayString(_ctx.user.usid) + " Balance", 1)
                  ], 512), [
                    [_vShow, !_ctx.loadingBalance]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode("div", _hoisted_40, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.dashboarddata.ewalletbalance).toFixed(2))) + " " + _toDisplayString(_ctx.dashboarddata.currency), 1)
                    ]),
                    _hoisted_41
                  ], 512), [
                    [_vShow, !_ctx.loadingBalance]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_42, [
                    _createVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode("div", _hoisted_45, _toDisplayString(_ctx.dashboarddata.travelgc), 1)
                    ]),
                    _hoisted_46
                  ], 512), [
                    [_vShow, !_ctx.loadingBalance]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode("div", _hoisted_50, _toDisplayString(_ctx.dashboarddata.productgc), 1)
                    ]),
                    _hoisted_51
                  ], 512), [
                    [_vShow, !_ctx.loadingBalance]
                  ])
                ], 512), [
                  [_vShow, !_ctx.loadingBalance]
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_52, [
          _createVNode("ul", _hoisted_53, [
            _createVNode("li", _hoisted_54, [
              _createVNode(_component_router_link, {
                to: "/dashboard/reminderspage",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_55
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_56, [
              _createVNode(_component_router_link, {
                to: "/dashboard/accountinfo",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_57
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_58, [
              _createVNode(_component_router_link, {
                to: "/dashboard/primemonitoring",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_59
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_60, [
              _createVNode(_component_router_link, {
                to: "/dashboard/mycoverage",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_61
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_62, [
              _createVNode(_component_router_link, {
                to: "/dashboard/coveragelist",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_63
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_64, [
              _createVNode(_component_router_link, {
                to: "/dashboard/packagepointslist",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_65
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_66, [
              _createVNode(_component_router_link, {
                to: "/dashboard/dreamlyf",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_67
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_68, [
              _createVNode(_component_router_link, {
                to: "/dashboard/myprospects",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_69
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.loading]
    ]),
    _createVNode(_component_router_view),
    _createVNode("div", _hoisted_70, [
      _withDirectives(_createVNode("button", _hoisted_71, " Click here ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProEncode, {
        sealpro_encode_modal: 'add_new_accountmodal',
        firstCoverage: _ctx.firstCoverage,
        allowClose: _ctx.allowClose,
        inputActivationDetail: _ctx.inputActivationDetail,
        isAddAccount: true,
        allowChangeName: false
      }, null, 8, ["firstCoverage", "allowClose", "inputActivationDetail"]),
      _withDirectives(_createVNode("button", _hoisted_72, " Click here ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProEncode, {
        key: _ctx.encode_now_sealpro_key,
        firstCoverage: _ctx.firstCoverage,
        sealpro_encode_modal: 'encode_now_sealpromodal',
        allowClose: false,
        inputActivationDetail: false,
        isAddAccount: false,
        allowChangeName: _ctx.allowChangeName
      }, null, 8, ["firstCoverage", "allowChangeName"]),
      _withDirectives(_createVNode("button", _hoisted_73, " Click here ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProAutoCoverage, {
        key: _ctx.encode_now_sealproautocoverage_key,
        firstCoverage: _ctx.firstCoverage,
        sealpro_encode_modal: 'encode_now_sealproautocoverage_modal',
        allowClose: false,
        inputActivationDetail: false,
        isAddAccount: false,
        allowChangeName: _ctx.allowChangeName
      }, null, 8, ["firstCoverage", "allowChangeName"])
    ])
  ], 64))
}